import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'INFTEContractRenewal';
  constructor(private idle: Idle, private _elementRef: ElementRef, private route: Router) {
    this.checkIdleTime(idle)
  }

  checkIdleTime(idle: Idle) {
    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(1800); //--Idle time set for 3600 seconds = 60 mins
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    idle.onIdleStart.subscribe(() => {
      this.logout();
    });
    this.reset();
  }

  ngOnInit() {
    this._elementRef.nativeElement.removeAttribute("ng-version");
}

logout(){
  this.route.navigate(['/logout']);
 }

 reset() {
   this.idle.watch();
 }
}
